import React from 'react';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Matches',
      value: stats?.totalMatches,
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      title: 'Active Conversations',
      value: stats?.activeConversations,
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      title: 'Pending Reveals',
      value: stats?.pendingReveals,
      gradient: 'from-amber-500 to-amber-600'
    },
    {
      title: 'Scheduled Meetings',
      value: stats?.scheduledMeetings,
      gradient: 'from-emerald-500 to-emerald-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`px-1.5 py-0.5 bg-gradient-to-r ${stat?.gradient} rounded`}>
              <span className="text-white text-[10px] font-medium uppercase tracking-wide">
                {stat?.title}
              </span>
            </div>
          </div>
          <div className="text-2xl font-bold text-gray-900">
            {stat?.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;